import { InputFieldConfig } from 'src/@vymo/ui/molecules/form/types';
import moment from 'moment';
import { SUPERVISOR_REVIEW_DOMAINTYPE } from 'src/modules/constants';
import { filterInputsWithValues } from '../details/queries';
import { SupervisorReviewGroup, SupervisorReviewItem } from './types';

const getReviewDate = (entity) => {
  const timestamp = entity?.reviewDatetime ?? entity?.createdTime;
  if (timestamp == null || timestamp === '') {
    return '';
  }

  const date = moment(Number(timestamp));
  return date.isValid() ? date.format('DD MMM YYYY hh:mm A') : '';
};

const getInputsAndGroups = (
  revyreConfig,
): { inputs: InputFieldConfig[]; groups: SupervisorReviewGroup[] } => {
  const workflowConfig = revyreConfig?.[SUPERVISOR_REVIEW_DOMAINTYPE];
  const { inputs = [], groups = [] } =
    workflowConfig?.detailsConfig ?? workflowConfig?.createConfig ?? {};

  return { inputs, groups };
};

/**
 * Maps supervisor review list results + workflow config into accordion/form items.
 */
export const getTransformedSupervisorReviews = (
  results,
  revyreConfig,
): SupervisorReviewItem[] => {
  const { inputs, groups } = getInputsAndGroups(revyreConfig);

  if (!Array.isArray(results)) {
    return [];
  }

  return results.flatMap((result, index) => {
    const entity = result?.mutatedEntity;

    if (!entity || typeof entity !== 'object' || Array.isArray(entity)) {
      return [];
    }

    const formValues = {};
    inputs.forEach((input) => {
      formValues[input.code] = { value: entity?.[input.code] };
    });

    return [
      {
        id: String(entity?.reviewId || entity?.id || index),
        date: getReviewDate(entity),
        disposition: String(
          entity?.reviewerDisposition?.name || entity?.status || '',
        ),
        inputs: filterInputsWithValues(inputs, formValues),
        formValues,
        grouping: groups,
      },
    ];
  });
};
